import { useLocation } from 'react-router-dom';

import { Navigate, NavigateProps } from './Navigate';

type Props = {
  searchValue: string | RegExp;
  replaceValue: string;
} & Omit<NavigateProps, 'to'>;

export const NavigateWithPathnameReplace = ({
  searchValue,
  replaceValue,
  ...rest
}: Props) => {
  const location = useLocation();

  return (
    <Navigate
      to={{
        pathname: location.pathname.replace(searchValue, replaceValue),
        search: location.search,
        hash: location.hash,
      }}
      {...rest}
    />
  );
};
